import { useEffect, useRef } from 'react';
export default function PortalConsumer(props) {
  var manager = props.manager,
    children = props.children;
  var _key = useRef(0);
  useEffect(function () {
    if (!manager) {
      throw new Error('Looks like you forgot to wrap your component with `<Portal.Host>` component.\n\n');
    }
    _key.current = manager.mount(children);
    return function () {
      manager.unmount(_key.current);
    };
  }, []);
  useEffect(function () {
    manager.update(_key.current, children);
  });
  return null;
}